import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridView = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Laag_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	style: { enableBackground: "new 0 0 17 17" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
			id: "Adobe_OpacityMaskFilter",
			filterUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 17,
			height: 17,
			children: /* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
			})
		}) }),
		/* @__PURE__ */ _jsx("mask", {
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 17,
			height: 17,
			id: "mask0_702_23_00000048459161442276590270000015332848516523298478_",
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3.5,
				y: -3.5,
				className: "st0",
				width: 24,
				height: 24
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "st1",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st2",
				d: "M0,7.5V0h7.5v7.5H0z M0,17V9.5h7.5V17H0z M9.5,7.5V0H17v7.5H9.5z M9.5,17V9.5H17V17H9.5z M1.5,6H6V1.5H1.5V6z  M11,6h4.5V1.5H11V6z M11,15.5h4.5V11H11V15.5z M1.5,15.5H6V11H1.5V15.5z",
				fill: "currentColor"
			})
		})
	]
});
export { SvgGridView as ReactComponent };
